<template lang="pug">
.pin.pin-xy.d-flex.align-items-center
  .container
    .row
      h1 Downloading receipts...
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Receipts',

  computed: {
    ...mapGetters('transactions', ['singleTransactions', 'receiptUrl']),
  },

  data(){
    return{
      mySelectedRow: [],
      fileList: [],
    }
  },

  created() {
    const id = this.$route.params.transactionId;
    this.setGlobalValue(id);
  },

  methods: {
    ...mapActions('transactions', ['getReceiptFromAWS', 'getSingleUserExpense','getReceiptLinks']),

    async setGlobalValue(value) {
      this.refreshTime = new Date().toString();
      await this.getReceiptLinks({ id: value });
      const data = this.singleTransactions;
      this.fileList = [];
      if (data.expenseReceipts.length) {
        // Get image list;
        await this.getReceiptFromAWS(data.expenseReceipts);
        this.receiptUrl.forEach(item => {
          const imagData = {
            name: item.name,
            url: item.url,
            id: item.id,
          };
          this.fileList.push(imagData);
          const anchor = document.createElement('a');
          anchor.href = imagData.url;
          anchor.target = '_blank';
          anchor.click();
        });
        console.log("reciept data", this.fileList);
      }
    },
  },
};
</script>
